import React, { Dispatch, SetStateAction } from 'react'
import { FileTree } from './FileTree';
import { ActionIcon, Button, Card, Center, Group, Loader, ScrollArea, Stack, Text, TextInput, Tooltip } from '@mantine/core';
import { ReportElement } from './types';
import { DraggableElement } from './DraggableElement';
import { IconCalculator } from '@tabler/icons-react';

type DataElementsProps = {
    elementTree: ReportElement[]
    selectedElements: ReportElement[]
    elementTreeLoading: boolean
    setSelectedElements: Dispatch<SetStateAction<any[]>>
    toggleElementSelection: ({ checked, element }: { checked: boolean, element: ReportElement }) => void
    removeElement: (element: ReportElement) => void
    moveItem: (dragIndex: number, hoverIndex: number) => void;
    creatingColumnsWithData: boolean
    onSave: () => void
    onClose: () => void
}

export const DataElements = ({ elementTree, elementTreeLoading, selectedElements, toggleElementSelection, removeElement, moveItem, creatingColumnsWithData, onSave, onClose }: DataElementsProps ) => {
    return (
        <Stack justify='space-between' h='100%'>
            <Group wrap='nowrap' align='flex-start' mt={15} h='100%'>
                <Stack w='35%'>
                    <Text>Available Data Elements</Text>
                    <Card withBorder>
                        <Group w='100%' justify='space-between' wrap='nowrap'>
                            <TextInput placeholder='Search Elements' w='100%' />
                            <Tooltip label='Formula Builder'>
                                <ActionIcon size='xl' variant='outline'>
                                    <IconCalculator style={{ width: '70%', height: '70%' }} stroke={1.5} />
                                </ActionIcon>
                            </Tooltip>
                        </Group>
                        <ScrollArea h='65vh'>
                            { elementTreeLoading ?
                            <Center mt={150}><Loader /></Center> :
                            <FileTree data={elementTree} handleSelect={toggleElementSelection} /> }
                        </ScrollArea>
                    </Card>
                </Stack>
                <Stack w='65%'>
                    <Text>Data Elements Selection</Text>
                    <Card withBorder>
                        <ScrollArea h='65vh'>
                            <Stack>
                                { selectedElements?.map((el, index) => (
                                    <DraggableElement moveItem={moveItem} field_code={el.field_code as string} text={el.text} index={index} element={el} removeElement={removeElement} />
                                ))}
                            </Stack>
                        </ScrollArea>
                    </Card>
                </Stack>
            </Group>
            <Group justify='flex-end' mb={20} mr={30}>
                <Button onClick={onClose} disabled={creatingColumnsWithData}>Cancel</Button>
                <Button onClick={onSave} disabled={creatingColumnsWithData}>Save</Button>
            </Group>
        </Stack>
    )
}